import React from "react";
import { ReserveTimeButton, ChangeButton } from "../../components/Buttons";
import { useTranslation } from "react-i18next";
import { isIlt } from "../../utils/course_utils";
import { assignmentTypes } from "../../constants";
import CourseActionButton from "../../components/Buttons/CourseActionButton";

const LearningPathListItemButtons = ({
  assignment,
  isStarted,
  startCourseClick,
  resumeCourseClick,
  changeEnrollmentClick,
  reserveTimeClick
}) => {
  const { t } = useTranslation();
  const courseCardButtons = [
    <CourseActionButton
      isEnrolled={!!assignment.enrolledCtoaId}
      courseType={assignment.courseType}
      onEnrollClick={startCourseClick}
      isStarted={isStarted}
      onResumeCourseClick={resumeCourseClick}
      prereqs={assignment.prerequisites || []}
      startDate={assignment.enrolledTrainingObject?.zonedStartDate}
      endDate={assignment.enrolledTrainingObject?.zonedEndDate}
      iltClassType={assignment.enrolledTrainingObject?.typeName}
      manualId={assignment.manualId}
      assignedTrainingObjectId={assignment.assignedTrainingObject?.id}
      key="course-action-button"
    />
  ];

  const activeVersions = assignment.versions;
  if (!!activeVersions && activeVersions.length > 0) {
    courseCardButtons.push(
      <ReserveTimeButton
        disabled={
          Array.isArray(assignment.prerequisites) &&
          assignment.prerequisites.length > 0
        }
        key="Reserve Time Button"
        onClick={reserveTimeClick}
      />
    );
  }
  if (
    assignment &&
    assignment.enrolledCtoaId &&
    assignment.assignmentType !== assignmentTypes.forceEnrolled &&
    assignment.versions &&
    assignment.versions.length > 1 &&
    isIlt(assignment)
  ) {
    courseCardButtons.push(
      <ChangeButton
        key="Change Enrollment"
        text={t("learningPathListView.changeEnrollmentBtn")}
        onClick={changeEnrollmentClick}
      />
    );
  }

  return courseCardButtons;
};

export default LearningPathListItemButtons;
